<template>
  <div class="ucenter_edxh">
    <div class="ucenter_edxh_div">
      <div class="ucenter_edxh_div_top">
        <div class="ucenter_edxh_div_top_img_H_text">
          <div class="ucenter_edxh_div_top_img_H_text_imgs_text">
            <img
              src="http://apiupss.ppfly.top/images/balance_icon1.svg"
              alt=""
            />
          </div>
          <div class="ucenter_edxh_div_top_img_text">
            <div>剩余额度</div>
            <div>
              <div class="ucenter_edxh_div_top_img_text_money">
                {{ dataforms.SYED }}
              </div>
              元
            </div>
            <div>立即充值</div>
          </div>
        </div>

        <div class="ucenter_edxh_div_top_img_H_text">
          <div class="ucenter_edxh_div_top_img_H_text_imgs_text">
            <img
              src="http://apiupss.ppfly.top/images/balance_icon2.svg"
              alt=""
            />
          </div>
          <div class="ucenter_edxh_div_top_img_text">
            <div>累计充值</div>
            <div>
              <div class="ucenter_edxh_div_top_img_text_money">
                {{ dataforms.LJCZ }}
              </div>
              元
            </div>
            <!-- <div>  </div> -->
          </div>
        </div>

        <div class="ucenter_edxh_div_top_img_H_text">
          <div class="ucenter_edxh_div_top_img_H_text_imgs_text">
            <img
              src="http://apiupss.ppfly.top/images/balance_icon3.svg"
              alt=""
            />
          </div>
          <div class="ucenter_edxh_div_top_img_text">
            <div>昨日消耗额度/流量</div>
            <div>
              <div class="ucenter_edxh_div_top_img_text_money">
                {{ dataforms.ZRXH }}
              </div>
              元/0M
            </div>
            <div>消耗详情</div>
          </div>
        </div>

        <div class="ucenter_edxh_div_top_img_H_text">
          <div class="ucenter_edxh_div_top_img_H_text_imgs_text">
            <img
              src="http://apiupss.ppfly.top/images/balance_icon4.svg"
              alt=""
            />
          </div>
          <div class="ucenter_edxh_div_top_img_text">
            <div>累计消耗额度/流量</div>
            <div>
              <div class="ucenter_edxh_div_top_img_text_money">
                {{ dataforms.LJXH }}
              </div>
              元/0M
            </div>
            <div>消耗详情</div>
          </div>
        </div>
      </div>
      <div class="ucenter_edxh_div_butt">
        <div class="ucenter_edxh_div_butt_left">
          <div class="ucenter_edxh_div_butt_left_top_butts">
            <div><el-button size="small" round>账户额度</el-button></div>
            <div><el-button size="small" round>额度消耗</el-button></div>
            <div><el-button size="small" round>额度消耗明细</el-button></div>
          </div>
          <div class="ucenter_edxh_div_butt_left_butt">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label=" " name="first"> </el-tab-pane>
              <el-tab-pane label="主账号余额" name="second">
                <div class="ucenter_edxh_div_butt_left_butt_s_echart">
                  <!-- <div
                    class="echart"
                    id="mychart"
                    series.itemStyle
                    :style="myChartStyle"
                  ></div> -->
                </div>
              </el-tab-pane>
              <el-tab-pane label="认证账号余额" name="third"
                >认证账号余额</el-tab-pane
              >
            </el-tabs>
          </div>
        </div>
        <div class="ucenter_edxh_div_butt_reft">
          <div class="ucenter_edxh_div_butt_reft_H">代理单价</div>
          <div class="ucenter_edxh_div_butt_reft_text">
            <div>
              <div>动态住宅</div>
              <div>￥70 /G</div>
            </div>
            <div>
              <div>动态数据中心</div>
              <div>￥20 /G</div>
            </div>
            <div>
              <div>动态 ISP</div>
              <div>￥110 /G</div>
            </div>
            <div>
              <div>静态住宅（月套餐）</div>
              <div>￥75 /IP</div>
            </div>
            <div>
              <div>独享数据中心（月套餐）</div>
              <div>￥48 /IP</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/requset/api";
export default {
  name: "ucenter_edxh",
  data() {
    return {
      dataforms: {},
      activeName: "second",

    };
  },
  methods: {
    onlodedata() {
      var this_ = this;
      const token = this.$cookies.get("userdata");
      console.log(token.data.user_data.id);
      // this.token = token.data.token;
      api
        .ye_get_user({}, token.data.token)
        .then((res) => {
          console.log(res.data.data);
          this_.dataforms = res.data.data;
          console.log("ssssss");

          console.log(this_.dataforms);

          console.log("ssssss");
          // this.totalData = res.data.data.Total; // 更新总数据条目数
        })
        .catch((err) => {
          console.log(err, "走失败");
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

  },
  created() {},
  mounted() {
    // this.onlodedata();
  },
};
</script>

  <style>
.ucenter_edxh {
  margin-top: 30px;
}
.ucenter_edxh_div {
  padding: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.ucenter_edxh_div_top {
  /* background-color: #080707; */
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: space-around;
}

.ucenter_edxh_div_top_img_H_text {
  width: 24%;
  display: flex;
  justify-content: left;
  background-color: #edf3fc;
  height: 192px;
  border-radius: 10px;
}
.ucenter_edxh_div_top_img_text > div:nth-child(1) {
  font-size: 15px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #96a5b8;
  text-align: left;
}
.ucenter_edxh_div_top_img_text > div:nth-child(2) {
  display: flex;
  align-items: flex-end;
  color: #0e0b3d;
  font-weight: 700;
  margin-top: 8px;
  position: relative;
  margin-bottom: 20px;
}
.ucenter_edxh_div_top_img_text > div:nth-child(3) {
  text-align: center;
  line-height: 36px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  color: #00c886;
  border: 1px solid #00c886;
  border-radius: 5px;
  padding: 0 25px 0 25px;
}
.ucenter_edxh_div_top_img_text {
  margin-left: 20px;
  margin-top: 50px;
}
.ucenter_edxh_div_top_img_H_text_imgs_text {
  margin-top: 50px;
  margin-left: 70px;
}
.ucenter_edxh_div_top_img_text_money {
  font-size: 28px;
}
.ucenter_edxh_div_butt {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.ucenter_edxh_div_butt_left {
  background-color: #edf3fc;
  width: 74%;
  border-radius: 10px;
}
.ucenter_edxh_div_butt_reft {
  background-color: #edf3fc;
  width: 25%;
  border-radius: 10px;
}
.ucenter_edxh_div_butt_reft_H {
  margin-top: 40px;
  text-align: left;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #18181b;
  padding-left: 44px;
  background-color: #edf3fc;
  height: 62px;
  line-height: 62px;
  border-bottom: 1px solid #edf2f6;
  box-sizing: border-box;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.ucenter_edxh_div_butt_reft_text {
  padding: 20px;
}
.ucenter_edxh_div_butt_reft_text > div {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  /* width: 300px; */
  margin-left: 25px;
}
.ucenter_edxh_div_butt_reft_text > div > div:nth-child(1) {
  font-family: SourceHanSansCN-Medium;
  font-size: 16px;
  color: #18181b;
}
.ucenter_edxh_div_butt_reft_text > div > div:nth-child(2) {
  color: #2d67cc;
  background: #f0f9ff;
  border-radius: 4px;
  height: 32px;
  line-height: 32px;
}
.ucenter_edxh_div_butt_left_top_butts {
  display: flex;
  justify-content: space-between;
  width: 280px;
  margin: 20px;
}
.ucenter_edxh_div_butt_left_butt_s {
  line-height: 70px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #0e0b3d;
  display: flex;
  justify-content: space-between;
  width: 220px;
  padding-left: 30px;
}
.ucenter_edxh_div_butt_left_butt_s_echart {
  margin-top: 50px;
}
</style>
